


































































import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'
import moment from 'moment'

import config from '../config'
import { Brand, Channel, Tag, Range, Campaign } from '../store/timeline'
import DateField from './DateField.vue'

@Component({
    props: {
        range: {
            type: Range,
            required: true,
        },
    },
    components: {
        DateField,
    },
})
export default class FalconIoRangeForm extends Vue {
    @State(s => s.timeline.campaigns) campaigns!: Campaign[]
    @State(s => s.timeline.channels) channels!: Channel[]
    @State(s => s.timeline.tags) tags!: Tag[]

    range!: Range

    valid = true
    saving = false

    titleRules = [
        (v: any) => v ? true : 'This field is required',
        (v: String) => v.length <= 50 ? true : 'Title must be no longer than 50 characters',
    ]

    async save() {
        const form: any = this.$refs.form
        if (!form.validate()) {
            return
        }
        this.saving = true
        try {
            await this.$store.dispatch('api/post', {
                path: 'range',
                data: this.serializeObj(),
            })
            this.$emit('saved')
            // FIXME this is only temporary while there is no incremental
            // reload implemented
            // await this.$store.dispatch('timeline/loadEntries')
        } finally {
            this.saving = false
        }
    }

    async ignore() {
        this.saving = true
        try {
            await this.$store.dispatch('api/post', {
                path: 'falcon.io/publish/items/ignore',
                data: {
                    falconio_id: this.range.falconio_id
                },
            })
            this.$emit('ignored')
        } finally {
            this.saving = false
        }
    }

    serializeObj() {
        return {
            brand_id: this.range.brand_id,
            title: this.range.title,
            text: this.range.text,
            start_date: this.range.start_date,
            start_time: this.range.start_time,
            end_date: this.range.end_date,
            end_time: this.range.end_time,
            channels: this.range.channels,
            campaign_id: this.range.campaign_id,
            tags: this.range.tags,
            medias: [],
            falconio_id: this.range.falconio_id,
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FalconIoRangeForm.vue